import React, { useEffect, useRef, useState } from "react";
import { Content, Wrapper } from "./styles";
import Loading from "components/Loading";
import HeaderBox from "components/HeaderBox";
import SearchBox from "components/SearchBox";
import MessageBox from "components/MessageBox";
import { useInventory } from "./useInventory";
import { Box, Button } from "@mui/material";
import InvGoodsItem from "./InvGoodsItem";
import DialogChangeInvGoods from "components/DialogChangeInvGoods";
import { INV_GOODS_CHANGE_MODE, INV_GOODS_CHANGE_TXT_TITLE } from "Common";
import { TiPlus } from "react-icons/ti";

const Inventory = () => {
    const { navigate, termSearch, setTermSearch
        , isLoading, setIsLoading
        , setReload
        , message, setMessage
        , dtInvGoods } = useInventory();
    const refTop = useRef();
    const [invGoods, setInvGoods] = useState({});
    const [changeInvGoodsFlg, setChangeInvGoodsFlg] = useState(INV_GOODS_CHANGE_MODE.NONE);


    // useEffect(() => {
    //     refTop.current.scrollTo(0, 0);
    //     return;
    // }, [siteList, refTop])

    const handleInventoryNew = () => {
        navigate('/inventory/new');
    }

    // const handleSelectSite = (siteID) => {
    //     navigate(`/site/${siteID}`);
    // }

    const handleShukko = (invGoods) => {
        setInvGoods({ ...invGoods });
        setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.SUB);
    }

    const handleNyuko = (invGoods) => {
        setInvGoods({ ...invGoods });
        setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.ADD);
    }
    const handleDetials = (invGoods) => {
        if (!invGoods?.ClientInventoryGoodsID) return;
        navigate(`/inventory/${invGoods.ClientInventoryGoodsID}`);
    }

    return (
        <Wrapper>
            <Loading isLoading={false} />
            <HeaderBox title={"在庫一覧"} haveCart />
            <div style={{ position: "relative" }}>
                <SearchBox setTermSearch={setTermSearch} placeholder={"商品名"}>
                </SearchBox>
                <Box sx={{ borderBottom: "solid 1px #ececec", px: 2, py: 1 }}>
                    <Button variant="outlined" fullWidth color="secondary" startIcon={<TiPlus />}
                        sx={{ fontSize: "1rem", fontWeight: "bold" }} onClick={() => { handleInventoryNew(); }}>
                        新規登録
                    </Button>
                </Box>
                <Content ref={refTop}>
                    {
                        dtInvGoods.map((item) => {
                            return (
                                <InvGoodsItem key={`inv_${item.ClientInventoryGoodsID}`} invGoods={item}
                                    handleNyuko={() => { handleNyuko(item); }}
                                    handleShukko={() => { handleShukko(item); }}
                                    handleDetials={() => { handleDetials(item); }}
                                />
                            );
                        })
                    }
                </Content>
            </div>
            <MessageBox message={message} setMessage={() => { }} />
            <DialogChangeInvGoods txtTitle={INV_GOODS_CHANGE_TXT_TITLE[changeInvGoodsFlg]}
                invGoods={invGoods}
                changeFlg={changeInvGoodsFlg}
                handleClose={() => { setChangeInvGoodsFlg(INV_GOODS_CHANGE_MODE.NONE); setInvGoods({}); }}
                setIsLoading={setIsLoading}
                setReload={setReload}
                setMessage={setMessage}
            />
        </Wrapper>
    )
}

export default Inventory;